import { AnimatePresence, motion } from "framer-motion";
import { ProcessStep } from "../GuidedProcess.types";
import React, { useState } from "react";
import MemoChervonIcon from "../../Components/ChervonIcon";

const listVariant = {
  hidden: {
    x: -10,
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
  },
};

type ActiveStepProps = {
  step: ProcessStep;
  selectedActionLabel?: string;
  hideContent?: boolean;
  handleNextStep: (nextStepIndex: number, nextStepId: number) => void;
};

const ActiveStep: React.FC<ActiveStepProps> = ({
  step,
  handleNextStep,
  hideContent,
  selectedActionLabel,
}) => {
  const setNextStep = (nextStepIndex, nextStepId) => {
    handleNextStep(nextStepIndex, nextStepId);
  };

  const [showContent, setShowContent] = useState<boolean>(false);

  const Content = (
    <>
      <div
        className="mjb--copy guided-process__step--content "
        dangerouslySetInnerHTML={{ __html: step.content }}
      ></div>

      {step.alert && (
        <div className="block-alert block-alert--info rte" data-glossary-ignore>
          <div dangerouslySetInnerHTML={{ __html: step.alert }}></div>
        </div>
      )}
    </>
  );
  return (
    <div className="guided-process__step active-step">
      <div className="guided-process__step--inner">
        <h2 className="h4">{step.title}</h2>

        {hideContent ? (
          <>
            <button
              className={`guided-process__step-accordion ${
                showContent ? "open" : ""
              }`}
              onClick={() => setShowContent(!showContent)}
              type="button"
            >
              <MemoChervonIcon />{" "}
              {showContent ? "Hide Details" : "More Details"}
            </button>
            <AnimatePresence>
              {showContent && (
                <motion.div
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  variants={listVariant}
                >
                  {Content}
                </motion.div>
              )}
            </AnimatePresence>
          </>
        ) : (
          Content
        )}

        {step.nextSteps && step.nextSteps.length > 0 && (
          <div className="guided-process__actions">
            <p>See what happens if:</p>

            <ul>
              {step.nextSteps.map((nextStep, nextStepIndex) => (
                <motion.li key={nextStepIndex} variants={listVariant}>
                  <button
                    className={`guided-process__actions--button ${
                      selectedActionLabel &&
                      selectedActionLabel === nextStep.label
                        ? "selected"
                        : ""
                    }`}
                    onClick={() => {
                      setShowContent(false);
                      setNextStep(nextStepIndex, nextStep.nextStepId);
                    }}
                  >
                    {nextStep.icon ? (
                      <div
                        className="icon"
                        dangerouslySetInnerHTML={{ __html: nextStep.icon }}
                      ></div>
                    ) : (
                      <div className="icon"></div>
                    )}
                    {nextStep.label}
                  </button>
                </motion.li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActiveStep;
